module.exports = __webpack_public_path__ + "img/cegep-garneau.9c173e51.webp";